import React from 'react';
import PropTypes from 'prop-types';
import classes from './External.module.scss';

const External = ({ type }) => (
  type ? (
    <div className={classes.container}>
      <div>
        {type} is not a retail template.
      </div>
    </div>) : null
);

External.propTypes = {
  /**
   * type of the component
  */
  type: PropTypes.string,
};

export default External;
